import axios from "axios";
import type { States } from "../../domain/entities/States";
import { ApiConfig } from "../config/apiConfig";

export class StatesApi {

  async getStates(countryId: string): Promise<States[]> {
    const response = await axios.get(ApiConfig.STATES, {
      params: {
        country_id: countryId,
      },
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return response.data.data.states.map((state: any) => ({
      id: state.id,
      name: state.name,
      country_id: state.country_id,
      code: state.code,
      created_at: state.created_at,
    }));
  }
}
